module.exports = __webpack_public_path__ + "img/male-child-hand.5c137645.svg";